import { OdcLoadTypeViewModel } from "./OdcLoadTypeViewModel";
import { ContainerNetworkType } from "./ContainerNetworkType";
import { PdsrKey } from "./PdsrKey";

export interface PdsrClientViewModel {
  PdsrId?: number;
  ContainerNetwork?: ContainerNetworkType;
  PlantGsdb?: string;
  DockCode?: string;
  SupplierGsdb?: string;
  UsedInFtlRoutes?: number;
  ODCs?: Array<OdcLoadTypeViewModel>;
  MegaLdm?: number;
  EuroLdm?: number;
  Weight?: number;
  CubicMeters?: number;
  ShipFrequency?: number;
  InScope: boolean;
}

export const findPdsrClientViewModelByKey = (
  pdsrs: PdsrClientViewModel[],
  pdsrKey: PdsrKey
): PdsrClientViewModel | undefined => {
  return pdsrs.find(
    (pdsr) =>
      pdsr.ContainerNetwork === pdsrKey.containerNetwork &&
      pdsr.PlantGsdb === pdsrKey.plantGsdb &&
      pdsr.DockCode === pdsrKey.dockCode &&
      pdsr.SupplierGsdb === pdsrKey.supplierGsdb
  );
};
